import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { SupporterVoice } from '#src/app/pages/actions/shared/types';

import {
	SupporterComments,
	type SupporterCommentsQuery,
	type SupporterCommentsQueryVariables,
} from './getSupporterComments.graphql';
import { gqlSupporterCommentToSupporterVoice } from './types';

type SupporterCommentsResponse = {
	isLastSupporterVoicesPage: boolean;
	supporterVoices: SupporterVoice[];
	endCursor: string | null;
};

export async function getSupporterComments(
	cursor: string | undefined,
	pageSize: number,
	petitionId: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<SupporterCommentsResponse> {
	const { data } = await fetch<SupporterCommentsQuery, SupporterCommentsQueryVariables>({
		query: SupporterComments,
		variables: { petitionSlugOrId: petitionId, first: pageSize, after: cursor ?? null },
		rejectOnError: true,
		batched: false,
	});

	const { nodes, pageInfo } = data.petitionSupporterCommentsConnection;
	return {
		supporterVoices: nodes.map(gqlSupporterCommentToSupporterVoice),
		isLastSupporterVoicesPage: !pageInfo.hasNextPage,
		endCursor: pageInfo.endCursor,
	};
}
